/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Side Nav Admin Icon component.
 */
export const SideNavProvisioningIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);

  return (
    <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none">
      <path d="M12.2236 2.1118C12.0828 2.04142 11.9172 2.04142 11.7764 2.1118L2.89443 6.55279C2.5259 6.73705 2.5259 7.26295 2.89443 7.44721L11.7764 11.8882C11.9172 11.9586 12.0828 11.9586 12.2236 11.8882L21.1056 7.44721C21.4741 7.26295 21.4741 6.73705 21.1056 6.55279L12.2236 2.1118Z"
        stroke={iconColor}
        strokeWidth={1.5}
        strokeMiterlimit={10} />
      <path d="M2 17L11.7764 21.8882C11.9172 21.9586 12.0828 21.9586 12.2236 21.8882L22 17"
        stroke={iconColor}
        strokeWidth={1.5}
        strokeMiterlimit={10} />
      <path d="M2 12L11.7764 16.8882C11.9172 16.9586 12.0828 16.9586 12.2236 16.8882L22 12"
        stroke={iconColor}
        strokeWidth={1.5}
        strokeMiterlimit={10} />
    </svg>
  );
};
